import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "size", "variant", "icon", "color", "bg"];
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { color } from 'styled-system';
import { fromTheme } from '../../utils';
import { Flex } from '../Flex';
import { BadgeSize, BadgeVariant } from './Badge.decl';
import { makeBadgeSize, makeBadgeIconSize, makeBadgeVariant, makeBadgePosition, shouldForwardProp } from './utils';
var BadgeIndicator = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Badge__BadgeIndicator",
  componentId: "sc-1ofwfxd-0"
})(["border-radius:50%;border:2px solid ", ";overflow:hidden;", " ", " ", " ", " ", ""], fromTheme('colors.base.white'), makeBadgePosition, makeBadgeVariant, makeBadgeSize, makeBadgeIconSize, color);
var BadgeIndicatorContent = styled.div.withConfig({
  displayName: "Badge__BadgeIndicatorContent",
  componentId: "sc-1ofwfxd-1"
})(["display:inline-flex;align-items:center;justify-content:center;position:absolute;top:0;right:0;left:0;bottom:0;"]);
var Badge = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? BadgeSize.MEDIUM : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? BadgeVariant.DEFAULT : _ref$variant,
      icon = _ref.icon,
      color = _ref.color,
      bg = _ref.bg,
      remainingStyleProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Flex, {
    display: "inline-flex",
    position: "relative",
    ref: ref
  }, children, /*#__PURE__*/React.createElement(BadgeIndicator, _extends({
    size: size,
    bg: bg,
    color: color,
    variant: variant,
    hasChildren: !!children
  }, remainingStyleProps), /*#__PURE__*/React.createElement(BadgeIndicatorContent, null, icon)));
});
export default Badge;